var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", { class: _vm.classes, on: { click: _vm.onClick } }, [
    _c(
      "div",
      { staticClass: "trbo-a-question-next-button__wrapper" },
      [
        _c("icon", {
          staticClass: "trbo-a-question-next-button__icon",
          attrs: { name: _vm.icon },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "trbo-a-question-next-button__title" }, [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }